<div class="custom-popup" *ngIf="showPopup">
    <gsp-confirmation-popup
        [heading]="title"
        [message]="message"
        [confirmAction]="confirmActionHandler"
        [isPermanentAction]="isPermanentAction"
        [confirmationButtonText]="confirmButtonText"
        (cancel)="cancelActionHandler()"
        [id]="id"
    ></gsp-confirmation-popup>
</div>
